import React from 'react'
import { LoadingOutlined } from '@ant-design/icons'
import styled from 'styled-components'

const UploadScanning = () => (
  <IconContainer>
    <LoadingOutlined /> Scanning...
  </IconContainer>
)

const IconContainer = styled.div`
  color: rgba(0, 0, 0, 0.85);
  font-size: 12px;

  svg {
    font-size: 12px;
  }
`

export default UploadScanning
